<div
  class="d-flex align-items-center"
  *ngIf="
    mostrarInputPreco && tabelasPreco && tabelasPreco.length > 1 && tabelaPrecoSelecionada
  "
>
  <div class="input-group">
    <input
      [id]="id"
      [disabled]="precoDesabilitado"
      (ngModelChange)="onChangePreco($event)"
      [ngModel]="preco"
      type="text"
      currencyMask
      inputmode="numeric"
      class="form-control"
      [options]="{
        prefix: prefixoMoeda,
        thousands: separadorMilhar,
        decimal: separadorDecimal,
        precision: casasDecimais
      }"
    />
    <div class="input-group-append">
      <button
        type="button"
        class="btn btn-outline-secondary"
        (click)="voltarParaSelecaoTabela()"
        ngbTooltip="Voltar para seleção de tabela"
      >
        <i class="fa fa-list"></i>
      </button>
    </div>
  </div>
</div>

<input
  [id]="id"
  [disabled]="precoDesabilitado"
  (ngModelChange)="onChangePreco($event)"
  [ngModel]="preco"
  *ngIf="
    mostrarInputPreco &&
    !(tabelasPreco && tabelasPreco.length > 1 && tabelaPrecoSelecionada)
  "
  type="text"
  currencyMask
  inputmode="numeric"
  class="form-control"
  [options]="{
    prefix: prefixoMoeda,
    thousands: separadorMilhar,
    decimal: separadorDecimal,
    precision: casasDecimais
  }"
/>

<ng-select
  #selectTabelaPreco
  *ngIf="mostrarSeletorTabela"
  [id]="idCombo"
  appendTo="body"
  (ngModelChange)="onChangeTabelaPreco($event)"
  [disabled]="disabled"
  [placeholder]="placeholder"
  [items]="tabelasPreco"
  bindLabel="nome"
  bindValue="preco"
  [ngModel]="tabelaPrecoSelecionada"
  [clearable]="true"
  [searchable]="true"
>
  <ng-template ng-option-tmp let-item="item">
    <div class="d-flex justify-content-between align-items-center">
      <span
        >{{ item.nome }} - {{ item.preco | currency : 'BRL' : 'symbol' : '1.2-2' }}</span
      >
    </div>
  </ng-template>

  <ng-template ng-label-tmp let-item="item">
    <span>{{ formatarPreco(item.preco) }}</span>
  </ng-template>
</ng-select>
